// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Article_wrapper__1Q_gs","title":"Article_title__3YpDd"};